import React, { FC } from 'react';
import { ImageProps, Image } from '@chakra-ui/react';

const BaseImage: FC<Partial<ImageProps>> = (props: Partial<ImageProps>) => {
  return (
    <>
      <Image layout='fill' loading='lazy' {...(props as any)} />
    </>
  );
};

export default BaseImage;
